module.exports = "/images/vendor/flag-icon-css/flags/4x3/ye.svg?b5840a84dc1fc44424947f817a83b8ce";